import { render, staticRenderFns } from "./NoContent.vue?vue&type=template&id=6ba6b5fa&scoped=true&"
import script from "./NoContent.vue?vue&type=script&lang=js&"
export * from "./NoContent.vue?vue&type=script&lang=js&"
import style0 from "./NoContent.vue?vue&type=style&index=0&id=6ba6b5fa&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ba6b5fa",
  null
  
)

export default component.exports